import { render, staticRenderFns } from "./BotoxConfigurazioneDiagnosiListPage.vue?vue&type=template&id=6ce612c1"
import script from "./BotoxConfigurazioneDiagnosiListPage.vue?vue&type=script&lang=js"
export * from "./BotoxConfigurazioneDiagnosiListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports